import {Tabs, TabsProps} from 'antd'
import ReportsPage from './reports/ReportsPage'
import DashboardsPage from './dashboards/DashboardsPage'
import {CustomStyle} from '../constants/CustomStyles'

const MainLandingPage = () => {
  const tabItems: TabsProps['items'] = [
    {

      label: 'REPORTS',
      key: '1',
      children: [
        <ReportsPage />,
      ]
    },
    {
      label: 'DASHBOARDS',
      key: '2',
      children: [
        <DashboardsPage/>,
      ],
    },
  ]

  return (
    <div style={CustomStyle} className="bg-white pt-10" >
      <Tabs defaultActiveKey="1"
            type="line"
            items={tabItems}
            color="warning"
            tabBarStyle={{marginBottom: "2px", color: "black", fontSize: "20px"}}
      />
    </div>
  );
}

export default MainLandingPage;